(function () {
  'use strict';

  if (window.FellinoraWhatIsBarfLoaded) {
    return;
  }

  window.FellinoraWhatIsBarfLoaded = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setDelays(section) {
    section.querySelectorAll('[data-fwb-stagger]').forEach(function (item) {
      var delay = Number(item.getAttribute('data-fwb-delay')) || 0;
      item.style.setProperty('--fwb-delay', delay + 'ms');
    });
  }

  function reveal(section) {
    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      section.classList.add('fwb-is-visible');
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        section.classList.add('fwb-is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.18 });

    observer.observe(section);
  }

  function initSection(section) {
    if (!section || section.dataset.fwbInitialized === 'true') return;
    setDelays(section);
    reveal(section);
    section.dataset.fwbInitialized = 'true';
  }

  function init(root) {
    (root || document).querySelectorAll('[data-fwb-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
